import PropTypes from 'prop-types';

const TestThumbnail = ({ color, className }) => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="120"
        height="120"
      >
        <rect width="120" height="120" rx="8" fill={color} />
      </mask>
      <g mask="url(#mask0)">
        <rect width="120" height="120" rx="8" fill={color} />
        <g style={{ mixBlendMode: 'multiply' }}>
          <rect width="120" height="120" rx="8" fill={color} />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 0C3.58172 0 0 3.58172 0 8V54.5882C15.4349 39.3828 36.6217 30 60 30C83.3783 30 104.565 39.3828 120 54.5882V8C120 3.58172 116.418 0 112 0H8Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M89.2457 73.6677C89.4781 73.9024 89.6642 74.1779 89.7943 74.48C89.931 74.7896 90.001 75.1238 90 75.4615V119.462C89.9911 120.132 89.7173 120.773 89.237 121.247C88.7567 121.721 88.1078 121.991 87.4286 122H32.5714C31.8922 121.991 31.2433 121.721 30.763 121.247C30.2826 120.773 30.0089 120.132 30 119.462V58.5385C30.0089 57.868 30.2826 57.2274 30.763 56.7532C31.2433 56.279 31.8922 56.0088 32.5714 56H70.2857C70.6278 55.999 70.9664 56.0681 71.28 56.2031C71.586 56.3315 71.865 56.5152 72.1028 56.7446L89.2457 73.6677ZM38.9074 72.7901C38.9074 69.0516 41.9381 66.0209 45.6767 66.0209H45.8525C49.591 66.0209 52.6217 69.0516 52.6217 72.7901C52.6217 76.5287 49.591 79.5594 45.8525 79.5594H45.6766C41.9381 79.5594 38.9074 76.5287 38.9074 72.7901ZM69.0364 64.5788L82.7507 78.1172H69.0364V64.5788ZM72.2082 91.5299H41.3511C40.6691 91.5299 40.0151 91.7973 39.5328 92.2734C39.0506 92.7494 38.7797 93.3951 38.7797 94.0683C38.7797 94.7416 39.0506 95.3872 39.5328 95.8633C40.0151 96.3394 40.6691 96.6068 41.3511 96.6068H72.2082C72.8902 96.6068 73.5443 96.3394 74.0265 95.8633C74.5087 95.3872 74.7797 94.7416 74.7797 94.0683C74.7797 93.3951 74.5087 92.7494 74.0265 92.2734C73.5443 91.7973 72.8902 91.5299 72.2082 91.5299ZM41.3511 105.069H61.9225C62.6045 105.069 63.2586 105.336 63.7408 105.812C64.223 106.288 64.4939 106.934 64.4939 107.607C64.4939 108.28 64.223 108.926 63.7408 109.402C63.2586 109.878 62.6045 110.146 61.9225 110.146H41.3511C40.6691 110.146 40.0151 109.878 39.5328 109.402C39.0506 108.926 38.7797 108.28 38.7797 107.607C38.7797 106.934 39.0506 106.288 39.5328 105.812C40.0151 105.336 40.6691 105.069 41.3511 105.069Z"
          fill="white"
        />
        <mask
          id="mask1"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="84"
          y="20"
          width="48"
          height="48"
        >
          <circle cx="108" cy="44" r="24" fill="white" />
        </mask>
        <g mask="url(#mask1)">
          <line
            x1="71.1484"
            y1="61.2067"
            x2="101.893"
            y2="3.0393"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="72.3439"
            y1="61.8385"
            x2="103.089"
            y2="3.67114"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="73.5397"
            y1="62.4703"
            x2="104.284"
            y2="4.30297"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="74.7355"
            y1="63.1032"
            x2="105.48"
            y2="4.93578"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="75.9314"
            y1="63.735"
            x2="106.676"
            y2="5.56762"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="77.1273"
            y1="64.3678"
            x2="107.872"
            y2="6.20043"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="78.3231"
            y1="64.9987"
            x2="109.068"
            y2="6.83129"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="79.5188"
            y1="65.6315"
            x2="110.263"
            y2="7.4641"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="80.7147"
            y1="66.2633"
            x2="111.459"
            y2="8.09594"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="81.9105"
            y1="66.8961"
            x2="112.655"
            y2="8.72875"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="83.1064"
            y1="67.528"
            x2="113.851"
            y2="9.36059"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="84.3022"
            y1="68.1588"
            x2="115.047"
            y2="9.99145"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="85.498"
            y1="68.7916"
            x2="116.243"
            y2="10.6243"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="86.6939"
            y1="69.4235"
            x2="117.439"
            y2="11.2561"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="87.8898"
            y1="70.0553"
            x2="118.634"
            y2="11.8879"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="89.0856"
            y1="70.6881"
            x2="119.83"
            y2="12.5207"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="90.2814"
            y1="71.32"
            x2="121.026"
            y2="13.1526"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="91.4774"
            y1="71.9508"
            x2="122.222"
            y2="13.7834"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="92.673"
            y1="72.5836"
            x2="123.418"
            y2="14.4163"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="93.8688"
            y1="73.2164"
            x2="124.613"
            y2="15.0491"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="95.0647"
            y1="73.8483"
            x2="125.809"
            y2="15.6809"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="96.2605"
            y1="74.4791"
            x2="127.005"
            y2="16.3118"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="97.4565"
            y1="75.111"
            x2="128.201"
            y2="16.9436"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="98.6522"
            y1="75.7448"
            x2="129.397"
            y2="17.5774"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="99.848"
            y1="76.3766"
            x2="130.593"
            y2="18.2092"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="101.044"
            y1="77.0084"
            x2="131.788"
            y2="18.8411"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="102.24"
            y1="77.6403"
            x2="132.985"
            y2="19.4729"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="103.436"
            y1="78.2711"
            x2="134.18"
            y2="20.1038"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="104.631"
            y1="78.9049"
            x2="135.376"
            y2="20.7375"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="105.827"
            y1="79.5367"
            x2="136.572"
            y2="21.3694"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="107.023"
            y1="80.1696"
            x2="137.768"
            y2="22.0022"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="108.218"
            y1="80.7994"
            x2="138.963"
            y2="22.6321"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="109.414"
            y1="81.4313"
            x2="140.158"
            y2="23.2639"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="110.61"
            y1="82.0641"
            x2="141.354"
            y2="23.8967"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="111.806"
            y1="82.6969"
            x2="142.55"
            y2="24.5295"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="113.001"
            y1="83.3297"
            x2="143.746"
            y2="25.1623"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="114.197"
            y1="83.9596"
            x2="144.942"
            y2="25.7922"
            stroke="white"
            strokeWidth="0.444588"
          />
          <line
            x1="115.393"
            y1="84.5934"
            x2="146.137"
            y2="26.426"
            stroke="white"
            strokeWidth="0.444588"
          />
        </g>
        <path
          d="M10.0739 11.1241C10.6104 14.5496 13.5597 17.1693 17.1176 17.1693C20.6395 17.1693 23.5651 14.6023 24.1443 11.2278C24.2185 10.911 24.2492 10.658 24.2398 10.4412C24.2398 10.1928 24.0628 10 23.8174 10H23.4194H10.8828H10.424C10.1788 10 10.0019 10.1925 10.0016 10.4406C10.0011 10.4406 10.0005 10.4406 10 10.4406C10.0003 10.4461 10.0007 10.4517 10.001 10.4572C9.99462 10.646 10.0182 10.8624 10.0739 11.1241L10.0739 11.1241Z"
          fill="white"
        />
        <path
          d="M20.6178 21.5581C20.3496 19.8453 18.8749 18.5355 17.0959 18.5355C15.335 18.5355 13.8722 19.819 13.5826 21.5062C13.5455 21.6646 13.5301 21.7911 13.5348 21.8995C13.5348 22.0237 13.6233 22.1201 13.746 22.1201H13.945H20.2134H20.4428C20.5654 22.1201 20.6538 22.0239 20.654 21.8998C20.6542 21.8998 20.6545 21.8998 20.6548 21.8998C20.6546 21.8971 20.6544 21.8943 20.6543 21.8915C20.6575 21.7971 20.6457 21.6889 20.6178 21.5581Z"
          fill="white"
        />
        <path
          d="M39.3714 16.9514C39.3714 17.755 39.7464 18.438 40.6839 18.438C41.6214 18.438 41.9964 17.755 41.9964 16.9514L41.9964 13.1211L43.55 13.1211L43.55 17.2327C43.55 18.6791 42.2375 19.8309 40.6839 19.8309C39.1304 19.8309 37.8179 18.6791 37.8179 17.2327L37.8179 13.1211L39.3714 13.1211L39.3714 16.9514Z"
          fill="white"
        />
        <path
          d="M44.4966 17.8616C44.5769 18.5982 45.3001 19.8303 47.1885 19.8303C48.8492 19.8303 49.6528 18.7321 49.6528 17.741C49.6528 16.7768 49.0099 16.0268 47.7778 15.7589L46.7867 15.558C46.385 15.4777 46.1305 15.2232 46.1305 14.875C46.1305 14.4732 46.5189 14.125 47.068 14.125C47.9385 14.125 48.2198 14.7277 48.2733 15.1027L49.5858 14.7277C49.4787 14.0848 48.8894 12.9063 47.068 12.9063C45.7153 12.9063 44.6707 13.8705 44.6707 15.0089C44.6707 15.9062 45.2734 16.6562 46.4251 16.9107L47.3894 17.125C47.9117 17.2321 48.1528 17.5 48.1528 17.8482C48.1528 18.25 47.818 18.5982 47.1751 18.5982C46.3448 18.5982 45.9028 18.0759 45.8492 17.4866L44.4966 17.8616Z"
          fill="white"
        />
        <path
          d="M28.3843 22.1205L28.3843 18.8392C28.7191 19.3348 29.4289 19.7366 30.3664 19.7366C32.2414 19.7366 33.4333 18.2634 33.4333 16.308C33.4333 14.3795 32.3485 12.9063 30.42 12.9063C29.4155 12.9063 28.6655 13.375 28.3441 13.9375L28.3441 13.0536L26.8441 13.0536L26.8441 22.1205L28.3843 22.1205ZM31.8798 16.308C31.8798 17.5535 31.1566 18.3571 30.1253 18.3571C29.1075 18.3571 28.3709 17.5535 28.3709 16.308C28.3709 15.0893 29.1075 14.2857 30.1253 14.2857C31.17 14.2857 31.8798 15.0893 31.8798 16.308Z"
          fill="white"
        />
        <path
          d="M34.8188 19.7767L34.8188 10L36.3599 10L36.3599 19.7767L34.8188 19.7767Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default TestThumbnail;

TestThumbnail.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

TestThumbnail.defaultProps = {
  className: '',
  color: 'var(--color-i-orange-1)'
};
